"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _defaults2 = _interopRequireDefault(require("lodash/defaults"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _forOwn2 = _interopRequireDefault(require("lodash/forOwn"));

var _validators = _interopRequireDefault(require("./validators"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Default options
var defaultOptions = {
  selector: 'name',
  labelFormatter: 'sentenceCase'
};
var ARRAY_KEY = 'array';
var RULES_KEY = 'rules';
/* eslint "max-params": 0 */
// This is an internal method and acceptable

var processRule = function processRule(value, myValidators, rule, result, attr, data) {
  (0, _forOwn2.default)(rule, function (v, key) {
    if (myValidators[key]) {
      var msg = myValidators[key](value, attr, v, data);

      if (msg === false) {
        return false;
      }

      if (msg) {
        // if we have an error msg but an overwritten msg is on
        // the rule, use that, else use the error msg

        /* eslint no-param-reassign: 0 */
        // We are mutating the object
        result.invalidAttrs[attr] = rule.msg ? rule.msg : msg;
        result.isValid = false;
        return false;
      }
    }

    return undefined;
  });
};

var getRule = function getRule(rules, ruleName) {
  var result;

  if ((0, _isArray2.default)(rules)) {
    (0, _forEach2.default)(rules, function (subRule) {
      if (!(0, _isUndefined2.default)(subRule[ruleName])) {
        result = subRule[ruleName];
      }
    });
  }

  return result || (rules || {})[ruleName];
};

var validate = function validate(data, rules, options) {
  var result = {
    isValid: true,
    invalidAttrs: {}
  }; // options for future exensibility

  var opts = (0, _defaults2.default)(options || {}, defaultOptions); // Determine if validation rules are applied and process them

  if (rules) {
    // for each defined rule set
    (0, _forOwn2.default)(rules, function (value, attr) {
      var attrValue = (0, _get2.default)(data, attr);

      if ((0, _isArray2.default)(attrValue) && rules[attr] && rules[attr][ARRAY_KEY]) {
        var arrayResult = validate(value, rules[attr], options);
        var subItemsResults = attrValue.reduce(function (rslt, v) {
          var r = validate(v, rules[attr][RULES_KEY], options);
          rslt.invalidAttrs = _objectSpread(_objectSpread({}, rslt.invalidAttrs), r.invalidAttrs);
          rslt.isValid = rslt.isValid ? r.isValid : rslt.isValid;
          return rslt;
        }, result);
        result.invalidAttrs = _objectSpread(_objectSpread({}, arrayResult.invalidAttrs), subItemsResults.invalidAttrs);
        result.isValid = arrayResult.isValid && subItemsResults.isValid;
      }

      if ((0, _isFunction2.default)(rules[attr])) {
        // if the value is a function, then execute it to get the message
        var msg = rules[attr](attrValue);

        if (msg) {
          result.invalidAttrs[attr] = msg;
          result.isValid = false;
        }
      } else if ((0, _isArray2.default)(rules[attr])) {
        // if the value is an array, then assume it to have objects with rules and messages
        (0, _forEach2.default)(rules[attr], function (rule) {
          processRule(attrValue, _validators.default, rule, result, attr, data);
        });
      } else if ((0, _isObject2.default)(rules[attr])) {
        // else for each validator on that field
        processRule(attrValue, _validators.default, rules[attr], result, attr, data);
      }
    });
  }

  return result;
};

var validation = {
  // determine if a field is required based on validation rules
  isRequired: function isRequired(attrName, rules) {
    return getRule(rules[attrName], 'required') || false;
  },
  getMaxLength: function getMaxLength(attrName, rules) {
    var maxLength = getRule(rules[attrName], 'maxLength');
    var rangeLength = getRule(rules[attrName], 'rangeLength');
    return maxLength || (rangeLength ? rangeLength[1] : undefined) || undefined;
  },
  validate: validate
};
var _default = validation;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/validation/index.js
// module id = 1834
// module chunks = 25